module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-HeavyItalic.17f8227.woff";